import { useCallback, useEffect, useRef } from 'react';

type IReturn<T> = [(data: T) => void, () => T | undefined];

export function useStack<T>(): IReturn<T> {
    // Don't change to useState - if change provide callback for async operations
    const ref = useRef<T[]>([]);
    const push = useCallback((data: T) => {
        ref.current.push(data);
    }, []);

    const pop = useCallback(() => {
        const val = ref.current.length ? ref.current.pop() : undefined;
        return val;
    }, []);

    useEffect(() => {
        return (): void => {
            ref.current = [];
        };
    }, []);

    return [push, pop];
}
